import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7f1fad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "node-badge-card"
}
const _hoisted_2 = { class: "node-badge-title color-purple" }
const _hoisted_3 = { class: "node-summary-literal" }
const _hoisted_4 = { class: "color-dark-gray" }

import { computed } from "vue";
import i18n from "@/core/i18n/i18n";
import { summarizeStepDelay } from "@/flow/utils/stepInputSummary";

interface IProps {
  step: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NodeDelaySummary',
  props: {
    step: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = i18n.global;

const delay = computed(() => summarizeStepDelay(props.step));

return (_ctx: any,_cache: any) => {
  return (delay.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("Flow.StepDelay")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(delay.value.raw), 1)
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("Flow.DelayGloss", { duration: delay.value.duration })), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})